import { Injectable } from '@angular/core';
import { IID_OL_SOLLECITO } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDolSollecitoStore } from './iidOlSollecito.store';
import { IIDolSollecitoQuery } from './iidOlSollecito.query';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ORDINE_OLO)
export class IIDolSollecitoService extends CrudService<IID_OL_SOLLECITO, IIDolSollecitoStore, IIDolSollecitoQuery> {
  constructor(
    protected store: IIDolSollecitoStore,
    public query: IIDolSollecitoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_SOLLECITO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
